import { Box, Divider, ListItem, ListItemIcon, ListItemText, MenuList, Typography } from '@mui/material'
import { graphHooks } from '@tunasong/graph-lib/react'
import type { Owned } from '@tunasong/models'
import { hasPublicAccess } from '@tunasong/models'
import type { ACL } from '@tunasong/schemas'
import type { FC } from 'react'
import { useMemo } from 'react'
import { UserAvatar } from '../profile/index.js'
import ACLList from './acl-list.js'

export interface ShareListProps {
  className?: string
  entity?: Owned
  /** Pending users */
  pending?: string[]
  onDelete(acl: ACL): void
}

export const ShareList: FC<ShareListProps> = props => {
  const { className, pending = [], entity, onDelete } = props
  const acls: ACL[] = useMemo(() => entity?.acls ?? [], [entity])
  const { profile: ownerProfile } = graphHooks.useProfile(entity?.userId)

  if (!Array.isArray(acls)) {
    return null
  }

  const ownerEmail = ownerProfile ? ownerProfile.email : 'Loading...'

  return (
    <Box className={className}>
      <MenuList>
        <ListItem>
          <ListItemIcon>
            <UserAvatar aria-label="user" userId={entity?.userId} />
          </ListItemIcon>
          <ListItemText primary={ownerEmail} secondary="Owner" />
        </ListItem>
        {hasPublicAccess(acls) && (
          <ListItem>
            <ListItemIcon>
              <UserAvatar aria-label="public" userId="PUBLIC" />
            </ListItemIcon>
            <ListItemText primary={'Public'} secondary={'READ'} />
          </ListItem>
        )}
        <Divider />
      </MenuList>
      {acls.length > 0 && (
        <Typography variant="subtitle1" sx={{ marginTop: theme => theme.spacing(2) }}>
          Collaborators
        </Typography>
      )}
      <ACLList entity={entity} onDelete={onDelete} pendingPrincipals={pending} />
    </Box>
  )
}

export default ShareList
